import { useState } from "react";

import { BsMetaUtil, MarketGuideMode, RoleView } from "@bridgesplit/abf-react";
import { DialogWrapper } from "@bridgesplit/ui";
import { TokenListMetadata } from "@bridgesplit/abf-sdk";
import { AppDialog, useAppDialog } from "app/utils";

import { MarketDialogHeader, MarketProvider, QuotesProvider } from "./common";
import { LendCardContent, MarketLendProvider } from "./lend";
import { MarketDialogWrapper } from "./dialog";

export default function LendDialog() {
    const { getData } = useAppDialog();
    const data = getData(AppDialog.Lend);

    const [tokenOverride, setToken] = useState<TokenListMetadata>();

    const token = tokenOverride ?? data?.token;
    const principalMint = token?.mint;

    return (
        <MarketProvider
            marketProps={{
                isDialog: true,
                token,
                selectToken: setToken,
                symbol: BsMetaUtil.getSymbol(token),
                loading: false,
                principalMint,
                view: RoleView.Lend
            }}
        >
            <QuotesProvider>
                <MarketLendProvider>
                    <DialogWrapper>
                        <MarketDialogWrapper>
                            <MarketDialogHeader mode={MarketGuideMode.Lend} header="Lend" />
                            <LendCardContent />
                        </MarketDialogWrapper>
                    </DialogWrapper>
                </MarketLendProvider>
            </QuotesProvider>
        </MarketProvider>
    );
}
